import AnalyticsTitle from "../AnalyticsTitle";
import { LANGUAGE, tt } from "../../../../utils/i18n/i18n";
import KC_DashboardCard from "../../../../designsystem/KC_Card/KC_DashboardCard";
import React, { useMemo } from "react";
import AnalyticsData from "../../model/AnalyticsData";
import TSUtils from "../../../../utils/helpers/TSUtils";
import Top3CTAs from "./Top3CTAs";
import CurrencyProp from "../model/CurrencyProp";
import { DEFAULT_CURRENCY } from "@tootsweet/model/enums/Currencies";

interface Props {
  data: AnalyticsData | undefined | null;
  currency?: CurrencyProp;
}

export default function (props: Props) {
  const language = useMemo(() => {
    return LANGUAGE.startsWith("fr") ? "fr" : "en";
  }, []);

  const totalBoostValue = useMemo(() => {
    if (!props.currency) {
      return 0;
    }
    return TSUtils.formatAmountUsingIntl(
      props.data?.totalBoostValue,
      props.currency.subUnits,
      props.currency.trigram
    );
  }, [props.data, props.currency]);

  return (
    <div className="row mt-1">
      <div className="col-12 co col-lg-4 flex-grow-1 d-flex flex-column mt-4 st-gap">
        <AnalyticsTitle title={tt("analytics_players")} />
        <KC_DashboardCard
          title={tt("active_players")}
          bigText={props.data?.nActivePlayers}
          className="flex-grow-1 k-dashboard-top-statistics-first-row"
        />

        <KC_DashboardCard
          title={tt("player_activity")}
          data1Title={tt("games_played")}
          data1Number={props.data?.nGamePlayed}
          data1Tooltip={
            props.data?.explanation?.nGamePlayed?.description?.[language]
          }
          data2Title={tt("games_won")}
          data2Number={props.data?.nGameOfChancePlayed}
          data2Tooltip={
            props.data?.explanation?.nGameOfChancePlayed?.description?.[
              language
            ]
          }
          data3Title={tt("redeem_voucher")}
          data3Number={props.data?.nRedeemed}
          data3Tooltip={
            props.data?.explanation?.nRedeemed?.description?.[language]
          }
          className="flex-grow-1 k-dashboard-top-statistics-second-row"
        />
      </div>
      <div className="col-12 col-lg-4 flex-grow-1 d-flex flex-column mt-4 st-gap">
        <AnalyticsTitle title={tt("analytics_finance")} />
        <KC_DashboardCard
          title={tt("generated_revenue", {
            currency: props.currency?.trigram || DEFAULT_CURRENCY
          })}
          bigText={totalBoostValue}
          className="flex-grow-1 k-dashboard-top-statistics-first-row"
        />
        <KC_DashboardCard
          title={tt("distribution")}
          data1Title={tt("repeat_business")}
          data1Number={props.data?.potentialRevenueFromExistingCustomers}
          data1IsCurrency={true}
          data1Tooltip={
            props.data?.explanation?.potentialRevenueFromExistingCustomers
              ?.description?.[language]
          }
          data2Title={tt("analytics_new_business")}
          data2Number={props.data?.potentialRevenueFromReferredCustomers}
          data2IsCurrency={true}
          data2Tooltip={
            props.data?.explanation?.potentialRevenueFromReferredCustomers
              ?.description?.[language]
          }
          data3Title={tt("actions_performed")}
          data3Number={props.data?.boostValueWithoutRedemption || 0}
          data3IsCurrency={true}
          data3Tooltip={
            props.data?.explanation?.boostValueWithoutRedemption?.description?.[
              language
            ]
          }
          className="flex-grow-1 k-dashboard-top-statistics-second-row"
          currency={props.currency}
        />
      </div>
      <div className="col-12 col-lg-4 flex-grow-1 d-flex flex-column mt-4 st-gap">
        <AnalyticsTitle title={tt("analytics_marketing")} />
        <KC_DashboardCard
          title={tt("actions_performed")}
          bigText={props.data?.nCTAs}
          className="flex-grow-1 k-dashboard-top-statistics-first-row"
        />
        <Top3CTAs data={props.data} />
      </div>
    </div>
  );
}
